<template>
  <Teleport to="body">
    <div v-if="modelValue" class="modal-backdrop" :style="{ zIndex: zIndexEfetivo }" @click.prevent.stop>
      <div class="modal-container shadow" @click.prevent.stop>
        <div class="text-center p-4">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Aguardando...</span>
          </div>
          <h5 class="mb-2">Aguardando resposta da Inteligência Artificial...</h5>
          <p class="text-muted mb-2">
            <i class="bi bi-exclamation-circle me-1"></i>
            O serviço de IA está temporariamente indisponível.
            Efetuando nova tentativa...
          </p>
          <div class="d-inline-block bg-light rounded-pill px-3 py-1 mt-1">
            <i class="bi bi-hourglass-split me-1 text-primary"></i>
            <span class="fw-semibold">Tentativa {{ tentativaAtual }} de {{ totalTentativas }}</span>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from 'vue'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

const props = defineProps({
  modelValue: Boolean,
  tentativaAtual: { type: Number, default: 1 },
  totalTentativas: { type: Number, default: 3 }
})

defineEmits(['update:modelValue'])

// --- Empilhamento (z-index) via registry central ---
const tokenZIndex = ref(null)
const zIndexReservado = ref(null)
const zIndexEfetivo = computed(() => zIndexReservado.value ?? BASE_ZINDEX)

watch(() => props.modelValue, (novoValor) => {
  if (novoValor) {
    const { token, zIndex } = reservarZIndex()
    tokenZIndex.value = token
    zIndexReservado.value = zIndex
  } else {
    liberarZIndex(tokenZIndex.value)
    tokenZIndex.value = null
    zIndexReservado.value = null
  }
})

onUnmounted(() => {
  liberarZIndex(tokenZIndex.value)
  tokenZIndex.value = null
  zIndexReservado.value = null
})
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
}
.modal-container {
  width: 90%;
  max-width: 480px;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 0.75rem;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
</style>
